<template>
  <div class="load">
    <el-form
      ref="form"
      class="load_form"
      :model="form"
      label-position="top"
      :rules="rules"
    >
      <titleBlock title="超时处理">
        <div class="flex align-center marginBottom">
          <el-switch
            v-model="form.LOADING_OVER_TIME.flag"
            active-color="#059E84"
            inactive-color="#D9DBDE"
          />
          <span class="switch_tips">开启时流程到达节点超时触发后将自动取消，关闭后不会自动取消。</span>
        </div>
        <div v-if="form.LOADING_OVER_TIME.flag" class="new-flex">
          <div class="second-title required">
            流程到达该节点
          </div>
          <el-form-item
            class="overTime_trigger"
            prop="LOADING_OVER_TIME_CONDITION.fieldName"
          >
            <div class="receiving_time flex align-center">
              <div class="flex align-center">
                <el-select
                  v-model="form.LOADING_OVER_TIME_CONDITION.fieldName"
                  placeholder="请选择"
                  class="receivingTimeType"
                >
                  <el-option
                    v-for="item in receivingTimeType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
                <el-select v-model="form.LOADING_OVER_TIME_CONDITION.action" class="receivingTimeTypeUnit">
                  <el-option
                    v-for="item in receivingStsgeType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </div>
            </div>
          </el-form-item>
          <el-form-item prop="LOADING_OVER_TIME_CONDITION.num">
            <div class="time_input flex align-center">
              <el-input v-model="form.LOADING_OVER_TIME_CONDITION.num" placeholder="请输入" />
              <el-select v-model="form.LOADING_OVER_TIME_CONDITION.unit">
                <el-option
                  v-for="item in timeUnit"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
              <span v-if="form.overTimeTrigger!==OVERTIME_TYPE.BASIS_TABLE_FIELD" class="basis">后</span>
            </div>
          </el-form-item>
        </div>
      </titleBlock>
    </el-form>
  </div>
</template>

<script>
import { processingSelectData } from '@/utils/index';
import titleBlock from '../assembly/titleBlock.vue';
import {
  timeReg, RECEIVING_TIME_TYPE,
  RECEIVING_STSGE_TYPE, TIME_UNIT, OVERTIME_TYPE,
} from './const';

export default {
  name: 'Load',
  components: {
    titleBlock,
  },
  props: {
    customField: {
      type: Object,
      default: () => { },
    },
    customerCode: {
      type: String,
      default: null,
    },
    form: {
      type: Object,
      default: () => {},
    },
    parentProcessName: {
      type: String,
      default: '',
    },
    parentProcessCode: {
      type: String,
      default: '',
    },
  },
  data() {
    const validateTime = (rule, value, callback) => {
      if (!timeReg.test(Number(value))) {
        callback('请输入正确的时间');
      }
      callback();
    };
    return {
      OVERTIME_TYPE,
      rules: {
        'LOADING_OVER_TIME.flag': [
          { required: true, message: '请选择接单设置', trigger: 'change' },
        ],
        'LOADING_OVER_TIME_CONDITION.fieldName': [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        'LOADING_OVER_TIME_CONDITION.num': [
          { required: true, validator: validateTime, trigger: 'change' },
        ],
      },
    };
  },
  computed: {
    timeUnit() {
      return processingSelectData(TIME_UNIT);
    },
    receivingTimeType() {
      return processingSelectData(RECEIVING_TIME_TYPE);
    },
    receivingStsgeType() {
      return processingSelectData(RECEIVING_STSGE_TYPE);
    },
  },
  methods: {
    async valiForm() {
      await this.$refs.form.validate();
      let data = Object.keys(JSON.parse(JSON.stringify(this.form)));
      if (!this.form.LOADING_OVER_TIME.flag) {
        data = data.filter((item) => item !== 'LOADING_OVER_TIME_CONDITION');
      }
      const res = data.map((item) => ({
        ruleCode: item,
        ruleValue: this.form[item],
      }));
      return {
        form: this.form,
        res,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.load {
  padding: 24px 24px 40px 24px;
}
.new-flex {
  display:flex;
  flex-wrap:wrap;
  .second-title{
    color:#404B5C;
    margin-bottom:8px;
    width:100%;
  }
  ::v-deep .el-form-item {
    margin-right:16px;
    .el-select{
      margin-right:8px;
    }
    .el-input{
      margin-right:8px;
    }
  }
}
.required:before{
  content:'*';
  color:red;
}
.marginBottom{
  margin:8px 0 24px;
}
.switch_tips{
  margin-left:12px;
  font-size: 13px;
  color:#808792;
}
</style>
